var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDniFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.152,73.763H35.648C16.487,73.763,0,88.778,0,107.948v294.941c0,19.169,16.487,35.349,35.648,35.349h442.504 c19.161,0,33.848-16.18,33.848-35.349V107.948C512,88.778,497.314,73.763,478.152,73.763z M494.644,402.889 c0,9.601-6.902,17.993-16.492,17.993H35.648c-9.589,0-18.292-8.392-18.292-17.993V107.948c0-9.603,8.703-16.829,18.292-16.829 h442.504c9.589,0,16.492,7.227,16.492,16.829V402.889z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M235.22,264.678h-7.922c5.035-13.017,7.905-27.763,7.905-43.68c0-48.661-26.682-86.926-60.746-86.926 c-34.064,0-60.746,38.337-60.746,86.998c0,15.917,2.87,30.591,7.904,43.608h-7.964c-23.894,0-44.229,18.883-44.229,42.807v43.39 c0,4.794,4.784,9.261,9.576,9.261h190.915c4.792,0,7.78-4.467,7.78-9.261v-43.39C277.695,283.561,259.136,264.678,235.22,264.678z  M174.458,151.282c23.521,0,43.39,31.792,43.39,69.424c0,37.631-19.869,69.424-43.39,69.424s-43.39-31.792-43.39-69.424 C131.068,183.074,150.937,151.282,174.458,151.282z M260.339,342.78H86.78v-35.295c0-14.356,12.551-25.451,26.873-25.451h17.064 c10.969,15.186,26.393,26.034,43.742,26.034c17.348,0,32.772-10.847,43.742-26.034h17.021c14.347,0,25.119,11.095,25.119,25.451 V342.78z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286.373,
    y: 160.542,
    width: 147.525,
    height: 17.356
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286.373,
    y: 203.932,
    width: 147.525,
    height: 17.356
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.729,
    y: 247.322,
    width: 130.169,
    height: 17.356
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 338.441,
    y: 290.712,
    width: 95.458,
    height: 17.356
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 338.441,
    y: 334.102,
    width: 95.458,
    height: 17.356
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDniFront);
export default __webpack_public_path__ + "static/media/DniFront.c1eb384073c298f69c798f32effc320b.svg";
export { ForwardRef as ReactComponent };